import css from "../../css/listing/right-form.module.css";

import React from "react";
import PropTypes from "prop-types";
import RequestForm from "./RequestForm";
import Agent from "./Agent";
import User from "./User";

const RightForm = (props) => {
    const { listing } = props;
    const { agent, owner_user, manager_user } = listing;

    return (
        <div className={css.rightForm}>
            {agent && (
                <div className={css.agent}>
                    <Agent agent={agent} listing={listing} isPrimary={true} />
                </div>
            )}
            {!agent && (
                <>
                    {manager_user && (
                        <div className={css.agent}>
                            <User user={manager_user} type="manager" />
                        </div>
                    )}
                    {owner_user && !manager_user && (
                        <div className={css.agent}>
                            <User user={owner_user} type="owner" />
                        </div>
                    )}
                </>
            )}
            {(agent || manager_user || owner_user) && (
                <RequestForm listing={listing} />
            )}
        </div>
    );
};

RightForm.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default RightForm;
